import { METRIC_NAME } from '@/constants';
import logUtils from '@/utils/logUtils';
import { smartReport, reportImmediate, reportDeferred } from '@/utils/metricHelper';

let paymentModule: any = null;
let cachedPaymentProxy: any = null;
let _entryData: any = null;
let _d: any = null;
let blackbox = ''

// 需要动态添加 blackbox 的方法列表
const METHODS_NEED_BLACKBOX = ['antiPayGroup'];
/**
 * 动态加载支付模块
 */
async function loadPaymentModule() {
    if (paymentModule) {
        return paymentModule;
    }
    try {
        if (typeof window.SiAntiPaySpider !== 'undefined') {
            paymentModule = window.SiAntiPaySpider;
        } else {
            // try {
            //     paymentModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ '@shein-risk/si_anti_spider_payment')
            // } catch (error) {
            // @ts-ignore
            paymentModule = require('@shein-risk/si_anti_spider_payment')
            // }
        }
        const paymentModule2 = paymentModule?.default || paymentModule;
        paymentModule2?.init({
            server_type: _entryData?.server_type,
            env: _entryData?.env,
            site_from: _entryData?.site_from,
            parentReport: {
                smartReport,
                reportImmediate,
                reportDeferred
            },
            data: _d
        });
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadPayment', url: 'si_anti_spider_payment' },
            value: 1,
            message: 'payment module load success',
        });

        return paymentModule;
    } catch (error) {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { type: 'loadPaymentError', url: 'si_anti_spider_payment' },
            value: 1,
            message: 'payment module load error',
            params: error
        });
        throw error;
    }
}

/**
 * 初始化入口函数
 */
export async function entry(
    data?: any,
    extra?: {
        server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'];
        env: keyof typeof import('@/constants')['DEBUG_ENV'];
        site_from: string;
    }
) {
    try {
        _d = data
        _entryData = extra
        await loadPaymentModule();
    } catch (error) {
        logUtils.info2('Pay module initialization failed', error as string);
    }
}

/**
 * 获取 blackbox 数据
 */
async function getBlackbox() {
    try {
        // 动态导入 td.ts 的 provideBlackbox 方法避免循环依赖
        const tdModule = await import('./td.js');
        const blackbox = await tdModule.provideBlackbox({
            validate_channel: _entryData?.channel,
            brand: _entryData?.brand
        });
        return blackbox;
    } catch (error) {
        logUtils.info2('Failed to get blackbox', error as string);
        return '';
    }
}

/**
 * 数据代理
 */
function createPaymentProxy(target: any) {
    return new Proxy(target, {
        get(obj, prop) {
            const originalValue = obj[prop];
            // 如果不是需要处理的方法,直接返回原值
            if (typeof prop !== 'string' || !METHODS_NEED_BLACKBOX.includes(prop)) {
                return originalValue;
            }
            // 如果是函数,返回包装后的函数
            if (typeof originalValue === 'function') {
                return function (...args: any[]) {
                    const result = originalValue.apply(obj, args);
                    // 调用antiPayGroup 方法 补充 blackbox 字段
                    if (result && typeof result === 'object' && prop === 'antiPayGroup') {
                        return {
                            ...result,
                            blackbox: blackbox || window?.__td_blackbox || ''
                        };
                    }
                    return result;
                };
            }
            return originalValue;
        }
    });
}

export async function antiPay(): Promise<any> {
    try {
        if (!blackbox) {
            blackbox = await getBlackbox();
        }
        await loadPaymentModule();
    } catch (error) {
        logUtils.info2('Pay module initialization failed', error as string);
        return null as any;
    }

    if (cachedPaymentProxy) {
        return cachedPaymentProxy;
    }
    cachedPaymentProxy = createPaymentProxy(paymentModule);
    return cachedPaymentProxy;
}